import { render, staticRenderFns } from "./MealScheduleTemplate.vue?vue&type=template&id=bbcef540&scoped=true&"
import script from "./MealScheduleTemplate.vue?vue&type=script&lang=js&"
export * from "./MealScheduleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcef540",
  null
  
)

export default component.exports